import React, { useCallback, useEffect, useState } from 'react';

// INTERFACES
import { TabsProps, TabsContentProps } from '../../interfaces/Tab.interface';

// STYLES
import { ContentHeader, TabContent, TabHeader, TabIcon, Tabs, TabsTitle, TabTitle } from './styles';

const Tab: React.FC<TabsProps> = ({ handleSelectedTab, isMobile, selectedTab, tabs, titleTabs }: TabsProps) => {
  const [activeTab, setActiveTab] = useState<any>(tabs[0]?.index ?? selectedTab);

  const handleTab = useCallback(
    (idx: number) => {
      if (handleSelectedTab) {
        handleSelectedTab(idx);
      }

      setActiveTab(idx);
    },
    [activeTab]
  );

  useEffect(() => {
    if (!activeTab) {
      if (selectedTab) {
        setActiveTab(selectedTab);
        return;
      }

      setActiveTab(tabs[0]?.index);
    }

    if (selectedTab !== activeTab) {
      setActiveTab(selectedTab);
    }
    
  }, [selectedTab, activeTab]);

  const splitTab = (actived: boolean, name: string) => {
    if (actived || !isMobile) {
      return name;
    }

    if (isMobile) {
      return `${name.substr(0, 3)}...`;
    }
  };

  const getTabIndex = ({ index }: any, idx: number) => {
    return index || idx;
  };

  return (
    <Tabs>
      <TabsTitle>{titleTabs}</TabsTitle>
      <TabHeader>
        {tabs.map((tab: TabsContentProps, idx: number) => {
          const index = getTabIndex(tab, idx);
          const isSelected = index === (activeTab || 0);

          return (
            <ContentHeader key={`tab-header-${index}`} activeTab={isSelected}>
              <TabTitle onClick={() => handleTab(index)}>{splitTab(isSelected, tab.name)}</TabTitle>
              <TabIcon activeTab={isSelected}>{tab.icon}</TabIcon>
            </ContentHeader>
          );
        })}
      </TabHeader>

      {tabs.map((tab: TabsContentProps, idx: number) => {
        const index = getTabIndex(tab, idx);
        const isSelected = index === (activeTab || 0);
        return (
          <TabContent key={`tab-content-${index}`} activeTab={isSelected}>
            {tab.tab}
          </TabContent>
        );
      })}
    </Tabs>
  );
};

export default Tab;
